import geoDetect from '@/js/helpers/location/geoDetect';
import getCities from '@/js/services/api/getCities';

export default async function () {
  const { city: cityName, coordinates } = await geoDetect();
  const [city] = await getCities.get({ query: cityName });

  return { city, coordinates };
}
